import { Directive, ElementRef, Input, NgZone, Renderer2 } from '@angular/core';

const X_PROP_NAME = 'clientX'

/**
 * 此组件只干一件事: 生成一个可拖拽的条, 用户拖动时, 改变当前组件的宽度/高度
 * 所以, 此组件依赖组件依赖正确的布局:
 * 父容器必须是 flex 容器; 必须有一个平级块是 flex-fill(tailwind 中的 flex-1), 填充剩余空间;
 * 平级的 flex-fill 块在哪侧, 拖动把手就应该设置在哪侧.
 */

@Directive({
  selector: '[xcResizable]'
})
export class ResizableDirective {
  /**
   * 大小改变时, 组件边界会向哪个方向移动, 也就是把手所在的方向.
   * 注意此行为由外部布局方式决定, 平级的 flex-fill 块在哪侧, 拖动把手就应该设置在哪侧.
   */
  @Input('xcResizable') orient: 'none' | 'left' | 'right'
  // | 'bottom' | 'top'

  initMouseX: number
  initWidth: number
  unlistenMouseMove
  
  constructor (
    public el: ElementRef,
    public renderer: Renderer2,
    public zone: NgZone,
    ) { }

  ngOnInit () {
    if (this.orient === 'none' || !this.orient) return
    const handler = document.createElement('div')
    this.renderer.addClass(handler, 'xc-resizable-handler')
    // 设置 style
    this.renderer.setStyle(handler, this.orient || 'left', '0')
    this.renderer.appendChild(this.el.nativeElement, handler)

    this.renderer.listen(handler, 'mousedown', (e) => {
      this.initMouseX = e[X_PROP_NAME]
      this.initWidth = parseInt(window.getComputedStyle(this.el.nativeElement).width.replace('px', ''))

      this.zone.runOutsideAngular(() => {
        this.unlistenMouseMove = this.renderer.listen('document', 'mousemove', (e) => {
          const curMouseX = e[X_PROP_NAME]
          const curWidth = this.initWidth - (curMouseX - this.initMouseX) * (this.orient === 'left' ? 1 : -1)
          this.renderer.setStyle(this.el.nativeElement, 'width', curWidth + 'px')
        })
        this.renderer.listen('document', 'mouseup', (e) => {
          if (this.unlistenMouseMove) this.unlistenMouseMove()
        })
      })

    })
    
  }
}
